import React, { useEffect, useState } from "react";
import GoogleMapReact from "google-map-react";
import CustomMarker from "./Marker";

interface MapProps {
  apiKey: string;
  locations: { lat: number; lng: number; name: string; address?: string; propertyAddress?: string; isOfficeLocation?: boolean }[];
  mapRef?: React.RefObject<HTMLDivElement>;
  height?: string | null;
  width?: string | null;
  showNumberLabel?: boolean;
  selectedLocation?: any;
  includeImageInMarker?: boolean;
  onView?: (id: string) => void;
}

const MapComponent: React.FC<MapProps> = ({
  apiKey,
  locations,
  mapRef,
  height,
  width,
  showNumberLabel,
  selectedLocation,
  onView,
  includeImageInMarker,
}) => {
  const [activeLocation, setActiveLocation] = useState<number | null>(null);
  const [locationSelected, setSelectedLocation] = React.useState<any>();

  React.useEffect(() => {
    setSelectedLocation(selectedLocation);
  }, [selectedLocation]);

  const [hoveredMarker, setHoveredMarker] = useState<{
    lat: number;
    lng: number;
    address?: string;
    top?: number;
    right?: number;
  }>();
  const [mapCenter, setMapCenter] = useState<{ lat: number; lng: number }>({
    lat: 0,
    lng: 0,
  });

  const handleMarkerLeave = () => {
    // setHoveredMarker(undefined);
  };

  useEffect(() => {
    if (locations?.length > 0) {
      const middleIndex = Math.floor(locations.length / 2);
      const middleLocation = locations[middleIndex];
      setMapCenter({ lat: middleLocation.lat, lng: middleLocation.lng });
    }
  }, [locations]);

  const handleMarkerHover = async (marker: {
    lat: number;
    lng: number;
    address?: string;
    top?: number;
    right?: number;
  }) => {
    try {
      setHoveredMarker(marker);
    } catch (error) {
      // console.error("Error fetching address:", error);
    }
  };

  return !!locations?.length ? (
    <div
      style={{
        height: height || "100vh",
        width: width || "100%",
        position: "relative",
      }}
      ref={mapRef}
    >
      <GoogleMapReact
        bootstrapURLKeys={{ key: apiKey, language: "en" }}
        defaultCenter={mapCenter} // Set the initial center of the map
        defaultZoom={13}
      >
        {locations?.map((location, index) => {
          const { lat, lng, name, address, propertyAddress } = location;
          if (!isNaN(lat) && !isNaN(lng)) {
            return (
              <CustomMarker
                key={index}
                lat={lat}
                lng={lng}
                name={name}
                address={address}
                propertyAddress={propertyAddress}
                isActive={activeLocation === index}
                onClick={() => setActiveLocation(index)}
                showNumberLabel={location.isOfficeLocation === true ? false : ( showNumberLabel || false)}
                onMarkerHover={handleMarkerHover}
                onMarkerLeave={handleMarkerLeave}
                showInfoWindow={
                  locationSelected?.lat === lat && locationSelected?.lng === lng
                }
                onView={onView}
                includeImageInMarker={includeImageInMarker}
                location={location}
              />
            );
          }
          return null;
        })}
      </GoogleMapReact>
    </div>
  ) : (
    <></>
  );
};

export default MapComponent;
